module.exports = __webpack_public_path__ + "img/you.582604dc.png";